export const styles = {
  popup: {
    width: '90vw',
    maxWidth: '940px',
    minHeight: '400px',
    maxHeight: '90vh',
    overflow: 'auto',
    padding: '1rem 1.5rem 1rem 1rem',

    '& div:has(button[title="Закрыть"])': {
      top: '0.5rem',
      right: '0.5rem',
    },
  },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
